import StatCard from "../../../components/StatCard";
import { StatSummary } from "../../../components/StatSummary";
import { AttendanceIcon } from "../../../shared/icons";
import { StaffAttendanceSummary } from "../../../service/model/staff-attendance.model";

const StaffAttendanceSummaryView = ({attendanceSummary}: {attendanceSummary: StaffAttendanceSummary}) => {

    return (
        <div>
            {attendanceSummary && 
                <StatSummary>
                    <StatCard title="Today" value={attendanceSummary.todayCount.toString()} icon={AttendanceIcon} />
                    <StatCard title="This Week" value={attendanceSummary.currentWeekCount.toString()} icon={AttendanceIcon} />
                    <StatCard title="This Month" value={attendanceSummary.currentMonthCount.toString()} icon={AttendanceIcon} />
                    <StatCard title="Last Month" value={attendanceSummary.lastMonthCount.toString()} icon={AttendanceIcon} />
                </StatSummary>
            }
        </div>
    )
}

export default StaffAttendanceSummaryView;